<template>
  <div class="d-flex flex-row flex-wrap" style="margin-bottom: 0.5rem;margin-left:-0.25rem;margin-right:-0.25rem">
    <div class="btn-group" style="width: 100%; display: flex; justify-content: space-between;flex: 1 0 50%; margin-bottom:0.5rem; padding: 0 0.25rem">
      <button class="btn" :class="previewClass" title="Preview (F5)" @click="toggle('preview')">{{
          previewText
        }}
      </button>
      <button class="btn" :class="previewClass" title="Update (F6)" @click="update('preview')">UPD</button>
      <button class="btn" :class="previewClass" title="Next (F7)" @click="next('preview')">NXT</button>
    </div>
    <div class="btn-group" style="width: 100%; display: flex; justify-content: space-between;flex: 1 0 50%; margin-bottom:0.5rem; padding: 0 0.25rem">
      <button class="btn" :class="programClass" title="Program (F9)" @click="toggle('program')">{{
          programText
        }}
      </button>
      <button class="btn" :class="programClass" title="Update (F10)" @click="update('program')">UPD</button>
      <button class="btn" :class="programClass" title="Next (F11)" @click="next('program')">NXT</button>
    </div>
  </div>
</template>

<script>
import * as action from '@/store/action-types'

const PREVIEW_TEXT = 'PRV'
const PROGRAM_TEXT = 'PRG'

export default {
  name: 'switch-buttons',
  props: {
    templateId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      previewText: PREVIEW_TEXT,
      previewTopUtc: null,
      programText: PROGRAM_TEXT,
      programTopUtc: null
    }
  },
  computed: {
    isPreview () {
      return this.$store.getters.isPlaying(this.templateId, 'preview')
    },
    isProgram () {
      return this.$store.getters.isPlaying(this.templateId, 'program')
    },
    previewClass () {
      return {
        'btn-outline-preview-off': !this.isPreview,
        'btn-preview-on': this.isPreview
      }
    },
    programClass () {
      return {
        'btn-outline-program-off': !this.isProgram,
        'btn-program-on': this.isProgram
      }
    }
  },
  methods: {
    toggle (channelId) {
      this.$store.dispatch(action.TOGGLE_PLAY_STOP, {
        templateId: this.templateId, channelId
      })
    },
    update (channelId) {
      this.$store.dispatch(action.COMMAND_UPDATE, {
        templateId: this.templateId, channelId
      })
    },
    next (channelId) {
      this.$store.dispatch(action.COMMAND_NEXT, {
        templateId: this.templateId, channelId
      })
    },
    updatePreviewButton () {
      if (this.previewTopUtc > 0) {
        const d = new Date(Date.now() - this.previewTopUtc)
        this.previewText = (d.getUTCHours() > 0 ? d.getUTCHours() + ':' : '') +
          ('0' + d.getUTCMinutes()).slice(-2) +
          ':' + ('0' + d.getUTCSeconds()).slice(-2)
        const delay = 1000 - d.getMilliseconds()
        window.setTimeout(this.updatePreviewButton.bind(this), delay)
      } else {
        this.previewText = PREVIEW_TEXT
      }
    },
    updateProgramButton () {
      if (this.programTopUtc > 0) {
        const d = new Date(Date.now() - this.programTopUtc)
        this.programText = (d.getUTCHours() > 0 ? d.getUTCHours() + ':' : '') +
          ('0' + d.getUTCMinutes()).slice(-2) +
          ':' + ('0' + d.getUTCSeconds()).slice(-2)
        const delay = 1000 - d.getMilliseconds()
        window.setTimeout(this.updateProgramButton.bind(this), delay)
      } else {
        this.programText = PROGRAM_TEXT
      }
    }
  },
  watch: {
    isPreview (val) {
      if (!val) {
        this.previewTopUtc = null
      } else {
        this.previewTopUtc = Date.now()
      }
      this.updatePreviewButton()
    },
    isProgram (val) {
      if (!val) {
        this.programTopUtc = null
      } else {
        this.programTopUtc = Date.now()
      }
      this.updateProgramButton()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/switch-buttons.vue